// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { SiteV3ClientGeneratedContactInformationPurposeType } from './siteV3ClientGeneratedContactInformationPurposeType.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class SiteV3ClientGeneratedWebAddressUpsearchModel {
    'webAddressId'?: number | null;
    'webAddressType'?: SiteV3ClientGeneratedContactInformationPurposeType;
    'url': string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof SiteV3ClientGeneratedWebAddressUpsearchModel>> = [
        {
            "name":     "webAddressId",
            "baseName": "webAddressId",
            "type":     "number"
        },
        {
            "name":     "webAddressType",
            "baseName": "webAddressType",
            "type":     "SiteV3ClientGeneratedContactInformationPurposeType"
        },
        {
            "name":     "url",
            "baseName": "url",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return SiteV3ClientGeneratedWebAddressUpsearchModel.attributeTypeMap;
    }
}
